import { gql } from '@apollo/client'

export const GET_COMPANY_TAGS = gql`
  query GetCompanyTags(
    $filters: CompanyTagFiltersInput
    $pageInfo: PageInfoInput
  ) {
    companyTags(filters: $filters, pageInfo: $pageInfo) {
      items {
        tagId
        createdAt
        updatedAt
        status
        label
        category
        createdBy {
          employeeId
          firstName
          lastName
          status
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const CREATE_COMPANY_TAG = gql`
  mutation CreateCompanyTag($input: CreateCompanyTagInput!) {
    createCompanyTag(input: $input) {
      tagId
      createdAt
      updatedAt
      status
      label
      category
    }
  }
`

export const UPDATE_COMPANY_TAG = gql`
  mutation UpdateCompanyTag($tagId: String!, $input: UpdateCompanyTagInput!) {
    updateCompanyTag(tagId: $tagId, input: $input) {
      tagId
      createdAt
      updatedAt
      status
      label
      category
    }
  }
`

export const DELETE_COMPANY_TAG = gql`
  mutation DeleteCompanyTag($tagId: String!) {
    deleteCompanyTag(tagId: $tagId) {
      tagId
      createdAt
      updatedAt
      status
      label
      category
    }
  }
`
